import React from 'react';
import {useHistory, useParams} from 'react-router-dom';
import {
  AddUsersInput,
  QueryGroupArgs,
  RemoveUsersInput,
  UpdateGroupInput,
  useAddUsersMutation,
  useGetGroupQuery,
  useRemoveUsersMutation,
  useUserListQuery,
  useUpdateGroupMutation
} from '../../graphql';
import {GroupEditContainer} from './container';
import {ErrorView} from '../GraphQL/ErrorView';

export const GroupEditGraphQL = () => {
  const history = useHistory();
  const {id} = useParams<QueryGroupArgs>();
  const [result, reexecuteQuery] = useGetGroupQuery({variables: {id}});
  const {data, fetching, error} = result;
  const [updateGroupResult, updateGroupPromise] = useUpdateGroupMutation();
  const updateGroup = (values: UpdateGroupInput) => {
    updateGroupPromise({input: {...values, id}}).then((result) => {
      history.push('/groups');
    })
  };
  const [UserListResult] = useUserListQuery();
  const {data: userData} = UserListResult;
  const users = userData?.users ?? [];
  const [addUserResult, addUserPromise] = useAddUsersMutation();
  const addUsers = (values: AddUsersInput) => {
    addUserPromise({input: {...values, id}}).then((result) => {
    })
  }
  const [removeUserResult, removeUserPromise] = useRemoveUsersMutation();
  const removeUsers = (values: RemoveUsersInput) => {
    removeUserPromise({input: {...values, id}}).then((result) => {
    })
  }

  return (
    <ErrorView fetching={fetching} errors={[error]}>
      <GroupEditContainer
        group={data?.group ?? undefined}
        updateGroup={updateGroup}
        addUsers={addUsers}
        removeUsers={removeUsers}
        users={users}
      />
    </ErrorView>
  );
};
